import useAuthStore from '../store/useAuthStore';

/**
 * Hook de compatibilidad que envuelve useAuthStore de Zustand.
 * Permite que los componentes existentes sigan funcionando sin cambios masivos.
 */
export function useAuth() {
    const {
      user,
      token,
      acl,
      vistas,
      loading,
      error,
      isAuthenticated,
      loginTenant,
      loginReference,
      loginGoogle,
      logout
    } = useAuthStore();

    return {
        user,
        token,
        acl,
        vistas,
        loading,
        error,
        isAuthenticated,
        logout,
        login: loginReference,
        loginTenant,
        loginReference,
        loginGoogle
    };
}
